import { render, staticRenderFns } from "./ReportBasicInfo.vue?vue&type=template&id=df2eb0a4&scoped=true"
import script from "./ReportBasicInfo.vue?vue&type=script&lang=js"
export * from "./ReportBasicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2eb0a4",
  null
  
)

export default component.exports